export const getItemFromLocalStorage = (key) => {
  const item = window.localStorage.getItem(key)

  // If the item is not found, return null
  if (item === null) {
    return null
  }

  // Try to parse the item as JSON
  try {
    return JSON.parse(item)
  } catch (e) {
    // If parsing fails, return the item as a string
    return item
  }
}
